import { Login } from '@k-mille/ui-login'
import Invoice from './invoice'
import Invoices from './invoices'

export default [
  Login,
  Invoice,
  Invoices,
]
